export default __webpack_public_path__ + "static/media/yt-white.64a99164.svg";